import { useAuth } from "../../context/AuthContext";
import { NotFound } from "../../components/page/notfound/NotFound";

/**
 * Protege children para que solo se rendericen si el rol del usuario
 * está en la lista permitida.
 *
 * Uso:
 *   <RequireRole roles={['AA-001', 'SA-001']}><AdminOnly /></RequireRole>
 *   <RequireRole roles={['SA-001']} fallback={<NotFound />}>...</RequireRole>
 */
export const RequireRole = ({ roles = [], children, fallback }) => {
    const { user } = useAuth();
    const userRole = user?.rol;

    const hasAccess = userRole && roles.includes(userRole);

    if (!hasAccess) {
        return fallback ?? <NotFound home="/" />;
    }

    return children;
};
